import Layout from "./Layout.jsx";

import DisputeIntake from "./DisputeIntake";

import Dashboard from "./Dashboard";

import ProtectedRoute from "./ProtectedRoute";

import Login from "./Login";

import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

const PAGES = {
    
    DisputeIntake: DisputeIntake,
    
    Dashboard: Dashboard,

    Login: Login,
    
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }
    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Routes>  

                <Route path="/login" element={<Login />} />          
                
                <Route path="/" element={<ProtectedRoute><DisputeIntake /></ProtectedRoute>} />
                
                
                <Route path="/DisputeIntake" element={<ProtectedRoute><DisputeIntake /></ProtectedRoute>} />
                
                <Route path="/Dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                
            </Routes>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router>
            <PagesContent />
        </Router>
    );
}
